const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const IMAGE_SERVER_URL =
  process.env.REACT_APP_API_SERVER_URL_FOR_IMAGE || API_BASE_URL;

/**
 * Image path'ini tam URL'ye dönüştürür
 * @param imagePath - Image path (relative veya absolute)
 * @returns Tam URL veya default thumbnail path
 */
export const getImageUrl = (imagePath: string | undefined | null): string => {
  if (!imagePath) {
    return '/default-thumbnail.jpg';
  }

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const baseUrl = IMAGE_SERVER_URL.endsWith('/')
    ? IMAGE_SERVER_URL.slice(0, -1)
    : IMAGE_SERVER_URL;
  const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${baseUrl}${path}`;
};
